import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export default function useNavigation() {
  const history = useHistory();

  /**
   * Navigate to display call screen
   */
  const displayCall = useCallback(() => history.push('/app/dialPad'), [
    history,
  ]);

  const conversations = useCallback(() => history.push('/app/conversations'), [
    history,
  ]);

  const chatView = useCallback(
    (state: { id: string }) => {
      history.push(`/app/conversations/${state.id}/view`, state);
    },
    [history]
  );

  const smsSenderView = useCallback(
    (state: { mobile: string } & any) => {
      history.push('/app/conversations/new', state);
    },
    [history]
  );

  return {
    displayCall,
    conversations,
    /**
     * Navigate to messages, e.g: app/conversations/[conversation_id]/view
     */
    chatView,
    smsSenderView,
  };
}
